import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";

class VolunteerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      volunteers: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" }
    };
  }

  showBusy(mode) {
    if (mode === true) {
      this.setState({ spinnerClass: "", dataClass: "collapse" });
    } else {
      this.setState({ spinnerClass: "collapse", dataClass: "" });
    }
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/volunteer"
      )
      .then(response => {
        this.setState({ volunteers: response.data });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Volunteer List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
              >
                Add Volunteer
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit Volunteer
              </button>
            </div>
            <AgGridReact
              rowData={this.state.volunteers}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                field="vno"
                headerName="Volunteer #"
                width={100}
                checkboxSelection
                filter={false}
                resizable
              />
              <AgGridColumn
                field="name"
                headerName="Name"
                width={150}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="phone"
                headerName="Phone #"
                width={110}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="location"
                headerName="Location"
                width={200}
                sortable
                resizable
                filter
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  onAddClick = e => {
    this.props.onClick("", this.state.dummy);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("AddEdit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Volunteer !!"
      });
    }
  };
}

export default VolunteerList;
